import React from "react";
import { Briefcase, Users, UserCheck, Eye } from "lucide-react";

export default function RecruiterStatsCards({
  analytics,
  jobs,
  shortlistItems,
  totalHiredCount,
  theme,
  onOpenJobsList,
  onOpenShortlisted,
  onOpenHired
}) {
  if (!analytics) return null;

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 12, marginBottom: 16 }}>
      {/* Card 1: Jobs Posted */}
      <div
        onClick={onOpenJobsList}
        style={{
          background: theme.surface,
          border: `1px solid ${theme.line}`,
          borderRadius: 10,
          padding: 18,
          cursor: "pointer",
          transition: "all 0.2s ease"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: 12, color: theme.textMute }}>Jobs Posted</div>
          <Briefcase size={16} color={theme.accent} />
        </div>
        <div style={{ fontSize: 24, fontWeight: 700, marginTop: 4 }}>{analytics.totalJobs || jobs?.length || 0}</div>
        <div style={{ fontSize: 10.5, color: theme.accent, marginTop: 6, display: "flex", alignItems: "center", gap: 4, fontWeight: 600 }}>
          <Eye size={12} /> Click to view details & apply
        </div>
      </div>

      {/* Card 2: Candidates Shortlisted */}
      <div
        onClick={onOpenShortlisted}
        style={{
          background: theme.surface,
          border: `1px solid ${theme.line}`,
          borderRadius: 10,
          padding: 18,
          cursor: "pointer",
          transition: "all 0.2s ease"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: 12, color: theme.textMute }}>Candidates Shortlisted</div>
          <Users size={16} color={theme.accent} />
        </div>
        <div style={{ fontSize: 24, fontWeight: 700, marginTop: 4 }}>{shortlistItems?.length || 0}</div>
        <div style={{ fontSize: 10.5, color: theme.accent, marginTop: 6, display: "flex", alignItems: "center", gap: 4, fontWeight: 600 }}>
          <Eye size={12} /> Click to view shortlisted list &rarr;
        </div>
      </div>

      {/* Card 3: Hired Analytics */}
      <div
        onClick={onOpenHired}
        style={{
          background: theme.surface,
          border: `1px solid ${theme.line}`,
          borderRadius: 10,
          padding: 18,
          cursor: "pointer",
          transition: "all 0.2s ease"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ fontSize: 12, color: theme.textMute }}>Hired Candidates</div>
          <UserCheck size={16} color="#22c55e" />
        </div>
        <div style={{ fontSize: 24, fontWeight: 700, marginTop: 4, color: "#22c55e" }}>{totalHiredCount}</div>
        <div style={{ fontSize: 10.5, color: "#22c55e", marginTop: 6, display: "flex", alignItems: "center", gap: 4, fontWeight: 600 }}>
          <Eye size={12} /> Click to view hires &rarr;
        </div>
      </div>

      {/* Card 4: Avg Trust Score */}
      <div style={{ background: theme.surface, border: `1px solid ${theme.line}`, borderRadius: 10, padding: 18 }}>
        <div style={{ fontSize: 12, color: theme.textMute }}>Avg. Trust Score of Hires</div>
        <div style={{ fontSize: 24, fontWeight: 700, marginTop: 4 }}>{analytics.avgTrustScoreHired || 0}</div>
        <div style={{ fontSize: 10.5, color: theme.textMute, marginTop: 6 }}>WIBIL Index Score</div>
      </div>
    </div>
  );
}
